<template>
	<div class="mm-page-main" v-loading="loading">
		<div class="page-header">
			<div class="page-title">MSO管理</div>
			<el-link @click="gotoruter('/AddMSO')" type="primary"><i class="el-icon-circle-plus"></i>添加MSO</el-link>
		</div>

		<div class="pagemain">
			<div class="pagetablebox">
				<el-table empty-text="暫無數據" :data="msos" border :header-cell-style="{background:'#FAFAFA'}">
					<el-table-column prop="name" label="MSO名稱" align="center" sortable>
						<template slot-scope="scope">
							<div class="phonecel">MSO名稱</div>
							<div>{{scope.row.name}}</div>
						</template>
					</el-table-column>
					<el-table-column label="LOGO" align="center" sortable>
						<template slot-scope="scope">
							<div class="phonecel">LOGO</div>
							<div><img v-if="scope.row.logo" :src="apiurl+scope.row.logo" alt="" style="height:30px;"></div>
						</template>
					</el-table-column>
					<el-table-column prop="opentime" label="創立時間" align="center" sortable>
						<template slot-scope="scope">
							<div class="phonecel">創立時間</div>
							<div>{{scope.row.opentime}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="status" label="狀態" align="center" sortable>
						<template slot-scope="scope">
							<div class="phonecel">狀態</div>
							<el-switch disabled="" v-model="scope.row.status" active-text="啟用" inactive-text="禁用"></el-switch>
						</template>
					</el-table-column>
					<el-table-column label="操作" align="center">
						<template slot-scope="scope">
							<div class="phonecel">操作</div>
							<el-button size="mini" @click="edit(scope.row.id)">編輯</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: false,
				msos: [],
			}
		},
		methods: {
			edit(id) {
				this.$router.push({
					name: '/EditMSO',
					path: '/EditMSO',
					params: {
						id: id
					}
				})
			},
			gotoruter(name) {
				this.$router.push(name)
			},
			getmso() {
				this.loading = true;
				this.post('/api/mso/index', {}).then((res) => {

					res.map((v) => {
						if (v.status == 0) {
							v.status = true;

						} else if (v.status == 1) {
							v.status = false;
						}

					})

					this.msos = res;
					this.loading = false;
				}).catch((err) => {
					this.loading = false;
					console.log(err)
				});
			}
		},
		created() {
			this.getmso();
		}
	}
</script>

<style scoped>
</style>
